import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import t from "./ArrayPool.js";
import s from "./Evented.js";
import { clone as i } from "./lang.js";
import { assumeNonNull as r } from "./maybe.js";
import n from "./ObjectPool.js";
import { schedule as h } from "./scheduling.js";
import { property as o } from "./accessorSupport/decorators/property.js";
import { ensureType as l, ensureOneOfType as a } from "./accessorSupport/ensureType.js";
import { shared as c } from "./accessorSupport/decorators/shared.js";
import { subclass as f } from "./accessorSupport/decorators/subclass.js";
import { trackAccess as _ } from "./accessorSupport/tracking.js";
import { SimpleObservable as m } from "./accessorSupport/tracking/SimpleObservable.js";

var _u;

var g = /*#__PURE__*/function () {
  function g() {
    _classCallCheck(this, g);

    this.target = null, this.cancellable = !1, this.defaultPrevented = !1, this.item = void 0, this.type = void 0;
  }

  _createClass(g, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.cancellable && (this.defaultPrevented = !0);
    }
  }, {
    key: "reset",
    value: function reset(e) {
      this.defaultPrevented = !1, this.item = e;
    }
  }]);

  return g;
}();

var p = new n(g, void 0, function (e) {
  e.item = null, e.target = null, e.defaultPrevented = !1, e.cancellable = !1;
}),
    d = function d() {};

function b(e) {
  return e ? e instanceof L ? e.toArray() : e.length ? Array.prototype.slice.apply(e) : [] : [];
}

function v(e) {
  if (e && e.length) return e[0];
}

function y(e, t, s, i) {
  var r = Math.min(e.length - s, t.length - i);
  var n = 0;

  for (; n < r && e[s + n] === t[i + n];) {
    n++;
  }

  return n;
}

function C(e, t, s, i) {
  t && t.forEach(function (t, r, n) {
    e.push(t), C(e, s.call(i, t, r, n), s, i);
  });
}

var A = new Set(),
    x = new Set(),
    E = new Set(),
    j = new Map();

var B = 0,
    L = _u = /*#__PURE__*/function (_s$EventedAccessor, _Symbol$iterator) {
  _inherits(u, _s$EventedAccessor);

  var _super = _createSuper(u);

  function u(e) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, e), _this._chgListeners = [], _this._notifications = null, _this._timer = null, _this._observable = new m(), _this.length = 0, _this._items = [], Object.defineProperty(_assertThisInitialized(_this), "uid", {
      value: B++
    });
    return _this;
  }

  _createClass(u, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(e) {
      return e ? Array.isArray(e) || e instanceof _u ? {
        items: e
      } : e : {};
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.removeAll();
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.items, "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "items",
    get: function get() {
      return _(this._observable), this._items;
    }
  }, {
    key: "items",
    set: function set(e) {
      this._emitBeforeChanges(1) || (this._splice(0, this.length, b(e)), this._emitAfterChanges(1));
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(e) {
      return "change" === e ? this._chgListeners.length > 0 : this._emitter.hasEventListener(e);
    }
  }, {
    key: "on",
    value: function on(e, t) {
      if ("change" === e) {
        var _e = this._chgListeners,
            _s = {
          removed: !1,
          callback: t
        };
        return _e.push(_s), this._notifications && this._notifications.push({
          listeners: _e.slice(),
          items: this._items.slice(),
          changes: []
        }), {
          remove: function remove() {
            this.remove = d, _s.removed = !0, _e.splice(_e.indexOf(_s), 1);
          }
        };
      }

      return this._emitter.on(e, t);
    }
  }, {
    key: "once",
    value: function once(e, t) {
      var s = this.on(e, t);
      return {
        remove: function remove() {
          s.remove();
        }
      };
    }
  }, {
    key: "add",
    value: function add(e, t) {
      if (_(this._observable), this._emitBeforeChanges(1)) return this;
      var s = this.getNextIndex(null != t ? t : null);
      return this._splice(s, 0, [e]), this._emitAfterChanges(1), this;
    }
  }, {
    key: "addMany",
    value: function addMany(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._items.length;
      if (_(this._observable), !e || !e.length) return this;
      if (this._emitBeforeChanges(1)) return this;
      var s = this.getNextIndex(t);
      return this._splice(s, 0, b(e)), this._emitAfterChanges(1), this;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      if (_(this._observable), !this.length || this._emitBeforeChanges(2)) return [];
      var e = this._splice(0, this.length) || [];
      return this._emitAfterChanges(2), e;
    }
  }, {
    key: "clone",
    value: function clone() {
      return _(this._observable), this._createNewInstance({
        items: this._items.map(i)
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this$_items;

      _(this._observable);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      var t = e.map(b);
      return this._createNewInstance({
        items: (_this$_items = this._items).concat.apply(_this$_items, _toConsumableArray(t))
      });
    }
  }, {
    key: "drain",
    value: function drain(e, t) {
      if (_(this._observable), !this.length || this._emitBeforeChanges(2)) return;
      var s = r(this._splice(0, this.length)),
          i = s.length;

      for (var _r = 0; _r < i; _r++) {
        e.call(t, s[_r], _r, s);
      }

      this._emitAfterChanges(2);
    }
  }, {
    key: "every",
    value: function every(e, t) {
      return _(this._observable), this._items.every(e, t);
    }
  }, {
    key: "filter",
    value: function filter(e, t) {
      var s;
      return _(this._observable), s = 2 === arguments.length ? this._items.filter(e, t) : this._items.filter(e), this._createNewInstance({
        items: s
      });
    }
  }, {
    key: "find",
    value: function find(e, t) {
      return _(this._observable), this._items.find(e, t);
    }
  }, {
    key: "findIndex",
    value: function findIndex(e, t) {
      return _(this._observable), this._items.findIndex(e, t);
    }
  }, {
    key: "flatten",
    value: function flatten(e, t) {
      _(this._observable);

      var s = [];
      return C(s, this, e, t), new _u(s);
    }
  }, {
    key: "forEach",
    value: function forEach(e, t) {
      return _(this._observable), this._items.forEach(e, t);
    }
  }, {
    key: "getItemAt",
    value: function getItemAt(e) {
      return _(this._observable), this._items[e];
    }
  }, {
    key: "getNextIndex",
    value: function getNextIndex(e) {
      _(this._observable);

      var t = this.length;
      return (e = null == e ? t : e) < 0 ? e = 0 : e > t && (e = t), e;
    }
  }, {
    key: "includes",
    value: function includes(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _(this._observable), this._items.includes(e, t);
    }
  }, {
    key: "indexOf",
    value: function indexOf(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return _(this._observable), this._items.indexOf(e, t);
    }
  }, {
    key: "join",
    value: function join() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ",";
      return _(this._observable), this._items.join(e);
    }
  }, {
    key: "lastIndexOf",
    value: function lastIndexOf(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length - 1;
      return _(this._observable), this._items.lastIndexOf(e, t);
    }
  }, {
    key: "map",
    value: function map(e, t) {
      _(this._observable);

      var s = this._items.map(e, t);

      return new _u({
        items: s
      });
    }
  }, {
    key: "reorder",
    value: function reorder(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length - 1;

      _(this._observable);

      var s = this.indexOf(e);

      if (-1 !== s) {
        if (t < 0 ? t = 0 : t >= this.length && (t = this.length - 1), s !== t) {
          if (this._emitBeforeChanges(4)) return e;
          this._splice(s, 1), this._splice(t, 0, [e]), this._emitAfterChanges(4);
        }

        return e;
      }
    }
  }, {
    key: "pop",
    value: function pop() {
      if (_(this._observable), !this.length || this._emitBeforeChanges(2)) return;
      var e = v(this._splice(this.length - 1, 1));
      return this._emitAfterChanges(2), e;
    }
  }, {
    key: "push",
    value: function push() {
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }

      return _(this._observable), this._emitBeforeChanges(1) || (this._splice(this.length, 0, e), this._emitAfterChanges(1)), this.length;
    }
  }, {
    key: "reduce",
    value: function reduce(e, t) {
      _(this._observable);

      var s = this._items;
      return 2 === arguments.length ? s.reduce(e, t) : s.reduce(e);
    }
  }, {
    key: "reduceRight",
    value: function reduceRight(e, t) {
      _(this._observable);

      var s = this._items;
      return 2 === arguments.length ? s.reduceRight(e, t) : s.reduceRight(e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      return _(this._observable), this.removeAt(this.indexOf(e));
    }
  }, {
    key: "removeAt",
    value: function removeAt(e) {
      if (_(this._observable), e < 0 || e >= this.length || this._emitBeforeChanges(2)) return;
      var t = v(this._splice(e, 1));
      return this._emitAfterChanges(2), t;
    }
  }, {
    key: "removeMany",
    value: function removeMany(e) {
      if (_(this._observable), !e || !e.length || this._emitBeforeChanges(2)) return [];
      var t = e instanceof _u ? e.toArray() : e,
          s = this._items,
          i = [],
          r = t.length;

      for (var _n = 0; _n < r; _n++) {
        var _e2 = t[_n],
            _r2 = s.indexOf(_e2);

        if (_r2 > -1) {
          var _e3 = 1 + y(t, s, _n + 1, _r2 + 1),
              _h = this._splice(_r2, _e3);

          _h && _h.length > 0 && i.push.apply(i, _h), _n += _e3 - 1;
        }
      }

      return this._emitAfterChanges(2), i;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      if (_(this._observable), this._emitBeforeChanges(4)) return this;

      var e = this._splice(0, this.length);

      return e && (e.reverse(), this._splice(0, 0, e)), this._emitAfterChanges(4), this;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (_(this._observable), !this.length || this._emitBeforeChanges(2)) return;
      var e = v(this._splice(0, 1));
      return this._emitAfterChanges(2), e;
    }
  }, {
    key: "slice",
    value: function slice() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.length;
      return _(this._observable), this._createNewInstance({
        items: this._items.slice(e, t)
      });
    }
  }, {
    key: "some",
    value: function some(e, t) {
      return _(this._observable), this._items.some(e, t);
    }
  }, {
    key: "sort",
    value: function sort(e) {
      if (_(this._observable), !this.length || this._emitBeforeChanges(4)) return this;
      var t = r(this._splice(0, this.length));
      return arguments.length ? t.sort(e) : t.sort(), this._splice(0, 0, t), this._emitAfterChanges(4), this;
    }
  }, {
    key: "splice",
    value: function splice(e, t) {
      _(this._observable);

      for (var _len3 = arguments.length, s = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        s[_key3 - 2] = arguments[_key3];
      }

      var i = (t ? 2 : 0) | (s.length ? 1 : 0);
      if (this._emitBeforeChanges(i)) return [];
      var r = this._splice(e, t, s) || [];
      return this._emitAfterChanges(i), r;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return _(this._observable), this._items.slice();
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return _(this._observable), this.toArray();
    }
  }, {
    key: "toLocaleString",
    value: function toLocaleString() {
      return _(this._observable), this._items.toLocaleString();
    }
  }, {
    key: "toString",
    value: function toString() {
      return _(this._observable), this._items.toString();
    }
  }, {
    key: "unshift",
    value: function unshift() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      return _(this._observable), !e.length || this._emitBeforeChanges(1) || (this._splice(0, 0, e), this._emitAfterChanges(1)), this.length;
    }
  }, {
    key: "_createNewInstance",
    value: function _createNewInstance(e) {
      return new this.constructor(e);
    }
  }, {
    key: "_splice",
    value: function _splice(e, t, s) {
      var _this2 = this;

      var i = this._items,
          r = this.itemType;
      var n, o;

      if (!this._notifications && this.hasEventListener("change") && (this._notifications = [{
        listeners: this._chgListeners.slice(),
        items: this._items.slice(),
        changes: []
      }], this._timer && this._timer.remove(), this._timer = h(function () {
        return _this2._dispatchChange();
      })), t) {
        if (o = i.splice(e, t), this.hasEventListener("before-remove")) {
          var _t = p.acquire();

          _t.target = this, _t.cancellable = !0;

          for (var _s2 = 0, _r3 = o.length; _s2 < _r3; _s2++) {
            n = o[_s2], _t.reset(n), this.emit("before-remove", _t), _t.defaultPrevented && (o.splice(_s2, 1), i.splice(e, 0, n), e += 1, _s2 -= 1, _r3 -= 1);
          }

          p.release(_t);
        }

        if (this.length = this._items.length, this.hasEventListener("after-remove")) {
          var _e4 = p.acquire();

          _e4.target = this, _e4.cancellable = !1;
          var _t2 = o.length;

          for (var _s3 = 0; _s3 < _t2; _s3++) {
            _e4.reset(o[_s3]), this.emit("after-remove", _e4);
          }

          p.release(_e4);
        }
      }

      if (s && s.length) {
        if (r) {
          var _e5 = [];

          var _iterator = _createForOfIteratorHelper(s),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _t4 = _step.value;

              var _s4 = r.ensureType(_t4);

              null == _s4 && null != _t4 || _e5.push(_s4);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          s = _e5;
        }

        var _t3 = this.hasEventListener("before-add"),
            _n2 = this.hasEventListener("after-add"),
            _h2 = e === this.length;

        if (_t3 || _n2) {
          var _r4 = p.acquire();

          _r4.target = this, _r4.cancellable = !0;

          var _o = p.acquire();

          _o.target = this, _o.cancellable = !1;

          var _iterator2 = _createForOfIteratorHelper(s),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _l = _step2.value;
              _t3 ? (_r4.reset(_l), this.emit("before-add", _r4), _r4.defaultPrevented || (_h2 ? i.push(_l) : i.splice(e++, 0, _l), this._set("length", i.length), _n2 && (_o.reset(_l), this.emit("after-add", _o)))) : (_h2 ? i.push(_l) : i.splice(e++, 0, _l), this._set("length", i.length), _o.reset(_l), this.emit("after-add", _o));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          p.release(_o), p.release(_r4);
        } else {
          if (_h2) {
            var _iterator3 = _createForOfIteratorHelper(s),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _e6 = _step3.value;
                i.push(_e6);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else i.splice.apply(i, [e, 0].concat(_toConsumableArray(s)));

          this._set("length", i.length);
        }
      }

      return (s && s.length || o && o.length) && this._notifyChangeEvent(s, o), o;
    }
  }, {
    key: "_emitBeforeChanges",
    value: function _emitBeforeChanges(e) {
      var t = !1;

      if (this.hasEventListener("before-changes")) {
        var _s5 = p.acquire();

        _s5.target = this, _s5.cancellable = !0, _s5.type = e, this.emit("before-changes", _s5), t = _s5.defaultPrevented, p.release(_s5);
      }

      return t;
    }
  }, {
    key: "_emitAfterChanges",
    value: function _emitAfterChanges(e) {
      if (this.hasEventListener("after-changes")) {
        var _t5 = p.acquire();

        _t5.target = this, _t5.cancellable = !1, _t5.type = e, this.emit("after-changes", _t5), p.release(_t5);
      }

      this._observable.notify();
    }
  }, {
    key: "_notifyChangeEvent",
    value: function _notifyChangeEvent(e, t) {
      this.hasEventListener("change") && this._notifications && this._notifications[this._notifications.length - 1].changes.push({
        added: e,
        removed: t
      });
    }
  }, {
    key: "_dispatchChange",
    value: function _dispatchChange() {
      var _this3 = this;

      if (this._timer && (this._timer.remove(), this._timer = null), !this._notifications) return;
      var e = this._notifications;
      this._notifications = null;

      var _iterator4 = _createForOfIteratorHelper(e),
          _step4;

      try {
        var _loop = function _loop() {
          var s = _step4.value;
          var e = s.changes;
          A.clear(), x.clear(), E.clear();

          var _iterator5 = _createForOfIteratorHelper(e),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _step5$value = _step5.value,
                  _t8 = _step5$value.added,
                  _s6 = _step5$value.removed;
              if (_t8) if (0 === E.size && 0 === x.size) {
                var _iterator6 = _createForOfIteratorHelper(_t8),
                    _step6;

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    var _e8 = _step6.value;
                    A.add(_e8);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              } else {
                var _iterator7 = _createForOfIteratorHelper(_t8),
                    _step7;

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    var _e9 = _step7.value;
                    x.has(_e9) ? (E.add(_e9), x.delete(_e9)) : E.has(_e9) || A.add(_e9);
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }
              }
              if (_s6) if (0 === E.size && 0 === A.size) {
                var _iterator8 = _createForOfIteratorHelper(_s6),
                    _step8;

                try {
                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                    var _e10 = _step8.value;
                    x.add(_e10);
                  }
                } catch (err) {
                  _iterator8.e(err);
                } finally {
                  _iterator8.f();
                }
              } else {
                var _iterator9 = _createForOfIteratorHelper(_s6),
                    _step9;

                try {
                  for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                    var _e11 = _step9.value;
                    A.has(_e11) ? A.delete(_e11) : (E.delete(_e11), x.add(_e11));
                  }
                } catch (err) {
                  _iterator9.e(err);
                } finally {
                  _iterator9.f();
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          var i = t.acquire();
          A.forEach(function (e) {
            i.push(e);
          });
          var r = t.acquire();
          x.forEach(function (e) {
            r.push(e);
          });
          var n = _this3._items,
              h = s.items,
              o = t.acquire();

          if (E.forEach(function (e) {
            h.indexOf(e) !== n.indexOf(e) && o.push(e);
          }), s.listeners && (i.length || r.length || o.length)) {
            var _e7 = {
              target: _this3,
              added: i,
              removed: r,
              moved: o
            },
                _t6 = s.listeners.length;

            for (var _i = 0; _i < _t6; _i++) {
              var _t7 = s.listeners[_i];
              _t7.removed || _t7.callback.call(_this3, _e7);
            }
          }

          t.release(i), t.release(r), t.release(o);
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      A.clear(), x.clear(), E.clear();
    }
  }], [{
    key: "isCollection",
    value: function isCollection(e) {
      return null != e && e instanceof _u;
    }
  }]);

  return u;
}(s.EventedAccessor, Symbol.iterator);

L.ofType = function (t) {
  if (!t) return _u;
  if (j.has(t)) return j.get(t);
  var s = null;
  if ("function" == typeof t) s = t.prototype.declaredClass;else if (t.base) s = t.base.prototype.declaredClass;else for (var _e12 in t.typeMap) {
    var _i2 = t.typeMap[_e12].prototype.declaredClass;
    s ? s += " | ".concat(_i2) : s = _i2;
  }

  var i = /*#__PURE__*/function (_u2) {
    _inherits(i, _u2);

    var _super2 = _createSuper(i);

    function i() {
      _classCallCheck(this, i);

      return _super2.apply(this, arguments);
    }

    return i;
  }(_u);

  return e([c({
    Type: t,
    ensureType: "function" == typeof t ? l(t) : a(t)
  })], i.prototype, "itemType", void 0), i = e([f("esri.core.Collection<".concat(s, ">"))], i), j.set(t, i), i;
}, e([o()], L.prototype, "length", void 0), e([o()], L.prototype, "items", null), L = _u = e([f("esri.core.Collection")], L);
var S = L;
export { S as default };